import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './constants';

export const usePersonsManagerStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: COLORS.bgPage,
    minHeight: 480,
  },
  title: {
    fontWeight: 700,
    color: COLORS.body,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: COLORS.muted,
    marginBottom: theme.spacing(2),
  },
  searchRow: {
    maxWidth: 480,
    marginBottom: theme.spacing(2),
  },
  searchIcon: {
    color: COLORS.muted,
  },
  grid: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    // Cap columns: wide screens max 4 (not auto-fill → 6–7); md tier 3; sm tier 2; mobile 1.
    gridTemplateColumns: 'minmax(0, 1fr)',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
    '& > *': {
      minWidth: 0,
    },
  },
  empty: {
    color: COLORS.muted,
    marginTop: theme.spacing(2),
  },
  pagination: {
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${COLORS.border}`,
    paddingTop: theme.spacing(2),
  },
}));
